import { StrategyService } from '@/services';

import { STRATEGIES } from '@consts';

const MATERIAL_SERVICE = {
    name: 'materialService',
    appliesTo: 'ACCOUNT',
    displayLocations: [
        {
            name: 'MY_CAMPAIGNS',
        },
    ],
    score: 0,
};

const USER_GUIDE = {
    name: 'userGuide',
    appliesTo: 'ACCOUNT',
    displayLocations: [
        {
            name: 'MY_CAMPAIGNS',
        },
    ],
    score: 0,
};

const DUMMY = [
    {
        appliesTo: 'ACCOUNT',
        conditions: [
            {
                name: 'alwaysTrue',
                success: true,
            },
        ],
        score: 50,
        displayLocations: [
            {
                name: 'MY_CAMPAIGNS',
            },
        ],
        name: 'normalProposalRequest',
    },
    {
        appliesTo: 'ACCOUNT',
        conditions: [
            {
                name: 'alwaysTrue',
                success: true,
            },
        ],
        score: 50,
        displayLocations: [
            {
                name: 'MY_CAMPAIGNS',
            },
        ],
        name: 'normalSelfMadeCampaign',
        action: {
            name: 'createCampaign',
            settings: {
                useCrawlerToPrefillCreatives: true,
                websiteUrl: '',
                appStoreUrl: '',
                playStoreUrl: '',
                skipWebOrApp: false,
                autoCreatives: true,
                onlyRemarketing: false,
            },
        },
    },
    {
        appliesTo: 'ACCOUNT',
        conditions: [
            {
                name: 'hasWebsite',
                success: true,
            },
        ],
        score: 70,
        displayLocations: [
            {
                name: 'MY_CAMPAIGNS',
            },
        ],
        name: 'webCampaign',
        action: {
            name: 'createCampaign',
            settings: {
                webOrApp: 'web',
                useCrawlerToPrefillCreatives: true,
                skipWebOrApp: true,
                autoCreatives: true,
                websiteUrl: 'adriel.com',
                appStoreUrl: '',
                playStoreUrl: '',
                onlyRemarketing: false,
            },
        },
    },
    {
        appliesTo: 'ACCOUNT',
        conditions: [
            {
                name: 'hasYelpAsset',
                success: true,
            },
            {
                name: 'hasNoYelpCampaignRunning',
                success: true,
            },
        ],
        score: 50,
        displayLocations: [
            {
                name: 'MY_CAMPAIGNS',
            },
        ],
        name: 'yelpCampaign',
        action: {
            name: 'createCampaign',
            settings: {
                webOrApp: 'web',
                skipWebOrApp: true,
                autoCreatives: true,
                channels: ['yelp'],
                websiteUrl: 'adriel.com',
                appStoreUrl: '',
                playStoreUrl: '',
                useCrawlerToPrefillCreatives: true,
                onlyRemarketing: false,
            },
        },
    },
];

const getDefaultState = () => ({
    fetched: false,
    strategies: DUMMY,
});

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setStrategies(state, { data = [], isKoUser }, rootGetters) {
            if (data.length) {
                const idx = data.findIndex(
                    R.propEq('name', 'normalProposalRequest')
                );

                if (idx > -1) {
                    const extraStrategies = isKoUser ? [USER_GUIDE] : [];

                    data = R.insertAll(R.inc(idx), extraStrategies, data);
                } else {
                    data = [...data];
                }
            } else {
                data = [];
            }

            state.strategies = data;
        },
        setFetched(state, value) {
            state.fetched = value;
        },
    },
    actions: {
        fetchAll({ commit, rootGetters }) {
            commit('setFetched', false);

            const isKoUser = rootGetters['user/isKoUser'];

            StrategyService.fetchAll()
                .then((data = []) => {
                    console.log({ data });
                    const _data = R.sortWith(
                        [R.descend(R.prop('score'))],
                        data
                    );
                    commit('setStrategies', { data: _data, isKoUser });
                })
                .finally(() => {
                    commit('setFetched', true);
                });
        },
    },
    getters: {
        byLocation:
            (state, _, _2, rootGetters) =>
            (location = '') => {
                // basic filter by location
                let filters = [
                    R.reject(
                        R.propEq('name', STRATEGIES.NORMAL_PROPOSAL_REQUEST)
                    ),
                    R.filter(
                        R.propSatisfies(
                            R.any(R.propEq('name', location)),
                            'displayLocations'
                        )
                    ),
                ];

                // Korean user shouldn't see yelp strategy
                if (rootGetters['user/isKoUser']) {
                    filters.push(
                        R.reject(R.propEq('name', STRATEGIES.YELP_CAMPAIGN))
                    );

                    filters.push((data) => {
                        const idx = data.findIndex(
                            R.propEq('name', 'normalProposalRequest')
                        );

                        if (idx > -1) {
                            return R.insertAll(R.inc(idx), [USER_GUIDE], data);
                        } else {
                            return [...data];
                        }
                    });
                }

                return R.compose(...filters, R.prop('strategies'))(state);
            },
    },
};
